import { render, staticRenderFns } from "./BillingReports.vue?vue&type=template&id=8f122164"
import script from "./BillingReports.vue?vue&type=script&lang=js"
export * from "./BillingReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports